import { Box, Flex, Text } from '@mantine/core';
import {
	getDocumentStatusLabel,
	KYCDocumentStatus,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/components/utils';
import { getKycStatusColor } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/statusStyling.helper.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	status: KYCDocumentStatus;
	isInherited?: boolean;
}

export const DocumentStatusDot = ({ status, isInherited = false }: Props) => {
	const tMipManage = useTranslationMipManage();
	const color = getKycStatusColor(status);
	const label = isInherited
		? tMipManage('acceptance_status.inherited')
		: getDocumentStatusLabel(status);

	return (
		<Flex align="center" gap={6}>
			<Box
				w={6}
				h={6}
				bg={color}
				style={{
					borderRadius: '50%',
					flexShrink: 0,
				}}
			/>
			<Text size="B6" c={color}>
				{label}
			</Text>
		</Flex>
	);
};
